var map = {
	"./alcohol.png": 595,
	"./arrow-left.png": 378,
	"./arrow-right.png": 8722,
	"./bas-colon.png": 710,
	"./bowel-cancer-UK.png": 9512,
	"./btn-arrow-blue-down.png": 1710,
	"./btn-arrow-blue-up.png": 7340,
	"./btn-start-diving.png": 6205,
	"./bulle-left.png": 8875,
	"./bulle-right.png": 9421,
	"./chapter.png": 7733,
	"./colon-expo.png": 4805,
	"./colon.png": 539,
	"./colonoscopy.png": 836,
	"./corps-colon.png": 5524,
	"./corps-humain.png": 7420,
	"./digestive-cancers-europe.png": 1062,
	"./digestive-cancers-europe2.png": 6142,
	"./european-code-against-cancer.png": 7958,
	"./externe.png": 8513,
	"./facebook.png": 4141,
	"./family-history.png": 3490,
	"./fin-colon-fond.png": 6757,
	"./fin-colon.png": 7692,
	"./fish.png": 7090,
	"./fobt.png": 2744,
	"./fond.png": 7581,
	"./guide-patients.png": 9961,
	"./instagram.png": 723,
	"./journal.png": 8334,
	"./knowing-your-biomarker.png": 4599,
	"./linkedin.png": 5975,
	"./logo.png": 5080,
	"./loupe.png": 989,
	"./machine.png": 8377,
	"./masque.png": 3155,
	"./meats.png": 8169,
	"./microscope.png": 2870,
	"./milk.png": 1219,
	"./nutrition-cancers.png": 1645,
	"./over-50.png": 6831,
	"./pecheur.png": 9896,
	"./pierre-fabre.png": 9286,
	"./plongeur-end.png": 147,
	"./plongeur-full.png": 8517,
	"./plongeur.png": 448,
	"./polyps-cut.png": 8346,
	"./polyps-large.png": 2672,
	"./polyps-little.png": 6461,
	"./polyps-medium.png": 9216,
	"./polyps.png": 4630,
	"./polyps2.png": 2272,
	"./polyps3.png": 5646,
	"./relax.png": 4173,
	"./run.png": 5742,
	"./smoke.png": 9158,
	"./super-colon.png": 2990,
	"./symptoms.png": 5335,
	"./tete-colon-fond.png": 6138,
	"./tete-colon.png": 9174,
	"./twitter.png": 1591,
	"./vegetables.png": 1408,
	"./video1.png": 3260,
	"./video2.png": 6163,
	"./video3.png": 2595,
	"./video4.png": 2851,
	"./video5.png": 3110,
	"./wcrf-2018.png": 596,
	"./wonderful-colon-titre-cn.png": 4158,
	"./wonderful-colon-titre-fr.png": 2312,
	"./wonderful-colon-titre.png": 6691,
	"./youtube.png": 2307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;